import Vue from 'vue';
import axios from 'axios';
import cookie from '../../plugins/vue-cookie';
import i18n from '../i18n';
import uuid from '../../shared/uuid'

Vue.prototype.$axios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL
});

Vue.prototype.$axios.interceptors.request.use(
  (config) => {
    return new Promise((resolve) => {

      if (!cookie.get('userIdentifier')) {
        cookie.set('userIdentifier', uuid(), { expires: '1Y' });
      }
      config.headers['user-identifier'] = cookie.get('userIdentifier');
      config.headers['Accept-Language'] = i18n.locale;
      resolve(config);
    });
  }
);